import { depascalizeKeys } from 'fast-case';
import { FeatureFlags } from '../constants';

export const prettifyFlagKeys = (featureFlagKeys: FeatureFlags) => {
  return depascalizeKeys(featureFlagKeys, ' ');
};
